import { useMutation } from "@tanstack/react-query";
import { changePasswordPayloadType, ResponseType } from "@Utils/types";
import { AuthApiService } from "@Api/auth-services";
import NotificationService from "../../../services/NotificationService";
import { ResetPasswordPayload } from "@Pages/AuthScreens/Login/types";

export const useResetPassword = (onSuccess: (payload: ResetPasswordPayload) => void) => {
	return useMutation<ResponseType, Error, ResetPasswordPayload>({
		mutationFn: (payload: ResetPasswordPayload) => AuthApiService.resetPassword(payload),
		onSuccess: ({ ok, response, data }: ResponseType, payload: ResetPasswordPayload) => {
			if (ok) {
				onSuccess(payload);
				NotificationService.success("Password has been reset successfully.");
				return;
			}
			NotificationService.error(data?.data?.metadata?.message);
			throw response.message;
		},
		onError: (err: any) => {
			throw err;
		}
	});
};


export const useChangePassword = (
  onSuccessCallback: () => void
) => {
  return useMutation<ResponseType, Error, changePasswordPayloadType>({
    mutationFn: (payload) =>
      AuthApiService.changePassword(payload),

    onSuccess: ({ ok, data }) => {
      if (ok) {
        NotificationService.success(
          "Password has been changed successfully."
        );
        onSuccessCallback(); 
      } else {
        NotificationService.error(
          data?.data?.metadata?.message ||
            "New password must be different from the current password."
        );
      }
    },

    onError: (err: any) => {
      NotificationService.error(
        err?.message || "New password must be different from the current password."
      );
    },
  });
};
